import AclName from '../AclName';

export default [
  // Uprawnienie do wyświetlania informacji o użytkowniku
  AclName.UserInfoDialogAccess,
];
